module.exports = {
  title: 'test',
  baseUrl: 'http://106.75.250.34:8081/api', // 测试项目地址
  baseApi: 'http://106.75.250.34:8081/api', // 测试api请求地址
  // APPID: 'xxx',
  // APPSECRET: 'xxx',
  // $cdn: 'https://www.sunniejs.cn/static'
}
